import { useMemo, useEffect } from "react";
import { getCountries, getCities } from "./constants/geography.js";

export function LocationFilter({
  selectedCountry,
  setSelectedCountry,
  selectedCity,
  setSelectedCity,
  stackVertical = false,
  className = "",
  fullHeight = false, // when true, each select fills the parent's height
  compact = false,    // NEW: shorter controls; takes precedence over fullHeight
}) {
  const countries = getCountries();
  const cities = useMemo(() => selectedCountry ? getCities(selectedCountry) : [], [selectedCountry]);

    useEffect(() => {
        // If user selected "All Cities" (""), keep it.
        if (selectedCity === "") return;

        // If current city isn't valid for the selected country, pick the first available.
        if (selectedCountry && !cities.includes(selectedCity)) {
            setSelectedCity(cities[0] || "");
        }
    }, [selectedCountry, selectedCity, cities, setSelectedCity]);


  // Wrapper layout: if compact, don't stretch to full height even if fullHeight was requested.
  const wrapperClasses = [
    stackVertical ? "flex flex-col" : "flex flex-wrap",
    compact ? "" : (fullHeight ? "h-full justify-between" : ""),
    compact ? "gap-1" : "gap-2",
    className,
  ].join(" ");

  // Control sizing for compact vs normal
  const selectSizeClasses = compact
    ? "h-8 text-xs px-2 py-1"
    : "h-10 text-sm p-2";

  return (
    <div className={wrapperClasses}>
      {/* Country */}
      <div className={stackVertical ? "w-full" : "flex-1 min-w-[200px]"}>
        <select
          aria-label="Country"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
          className={[
            "w-full border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500",
            "font-bold text-center", // make text bold and centered
            selectSizeClasses,
          ].join(" ")}
        >
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
      </div>

      {/* City */}
      <div className={stackVertical ? "w-full" : "flex-1 min-w-[200px]"}>
        <select
          aria-label="City"
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          className={[
            "w-full border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500",
            "font-bold text-center", // make text bold and centered
            selectSizeClasses,
          ].join(" ")}
        >
          <option value="">All Cities</option>
          {cities.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
